<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>El fuerte de Guadalupe</h2>
    <img @click="imageClicked(0)" src="galerias/sala3/S3_G3.jpg" class="mainphoto"/>
    <p class="photo-description">Título: <b>Patio del Fuerte de Guadalupe</b><br>
      Técnica: Fotografía digital<br>
      Colección: INAH<br>
    </p>
    <p>El fuerte de Guadalupe fue el escenario principal de la Batalla del 5 de Mayo. En esta zona había un templo dedicado a la Virgen de Guadalupe, pero días antes de la llegada de los franceses este fue demolido y adaptado como fuerte para la defensa de la ciudad.</p>
    <p>Hoy en día este importante sitio histórico forma parte del “Centro Cívico Cultural 5 de Mayo” un espacio urbano  que reúne Parques, Foros y Museos.</p>
    <p>El fuerte de Guadalupe fue además rehabilitado y convertido en un museo en el que se preserva la memoria de la Batalla del 5 de Mayo.</p>
    <h5>Ver más:</h5>
    <p>Imagen propiedad del Instituto Nacional de Antropología e Historia, para conocer más de la historia de este sitio visita:<br>
      <a target="_blank" href="https://mediateca.inah.gob.mx/islandora_74/islandora/object/museo%3A1550">mediateca.inah.gob.mx</a>
    </p>
    <h3>El fuerte de Guadalupe en 1962</h3>
    <img @click="imageClicked(1)" src="galerias/sala3/S3_SubG3.jpg" class="mainphoto"/>
    <p class="photo-description">Título: <b>Ruinas del fuerte de Guadalupe</b><br>
    Autor: 
    Agustín Víctor Casasola<br>
      Año: 1962<br>
      Técnica: Fotografía<br>
      Colección: Fototeca Nacional<br>
    </p>
    <br>
    <p>En esta fotografía tomada por Agustín Víctor Casasola, un importante fotógrafo mexicano, se muestran las ruinas del Fuerte de Guadalupe en 1962, año en el que el presidente Adolfo López Mateos visitó la ciudad de Puebla con motivo del centenario de la Batalla del 5 de Mayo.</p>
    <p>La historia de este sitio se remonta hasta la época Virreinal, cuando, en el siglo XVI, se construyó una ermita dedicada a  San Cristóbal. Más adelante durante los siglos XVII y XVIII existió un templo consagrado a Nuestra Señora de Belén. La última construcción religiosa que coronó el cerro fue la iglesia de la Virgen de Guadalupe consagrada en 1816 y demolida en 1862.</p>
    <h5>Ver más:</h5>
    <p>Imagen propiedad del Instituto Nacional de Antropología e Historia, alojada en:<a target="_blank" href="http://mediateca.inah.gob.mx/repositorio/islandora/object/fotografia%3A254745">mediateca.inah.gob.mx</a></p>
  </div>
</template>

<script>
export default {
  name: "s32g03",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    },
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
